import React from "react"
import FormSection from "./FormSection"
import TextInput from "./TextInput"

export default function Details() {
  const inputs = [
    {
      label: "First Name",
      name: "firstname",
      type: "text",
    },
    {
      label: "Last Name",
      name: "lastname",
      type: "text",
    },
    {
      label: "Phone Number",
      name: "phone",
      type: "text",
    },
    {
      label: "Email",
      name: "email",
      type: "email",
    },
    {
      label: "Street Address",
      name: "address",
      type: "text",
    },
    {
      label: "Postcode",
      name: "postal_code",
      type: "text",
    },
    {
      label: "City",
      name: "city",
      type: "text",
    },
    {
      label: "State/Region",
      name: "state",
      type: "text",
    },
  ]

  return (
    <FormSection title="Your Details" className="bg-gray-100">
      <div className="grid grid-cols-2 gap-4">
        {inputs.map(input => (
          <TextInput
            label={input.label}
            name={input.name}
            type={input.type}
            placeholder={input.placeholder}
            className="flex flex-col mr-32"
          />
        ))}
      </div>
    </FormSection>
  )
}
